import React from 'react';

interface DeleteIconProps extends React.SVGProps<SVGSVGElement> {
  size?: string | number;
}

export const DeleteIcon: React.FC<DeleteIconProps> = ({ size = '1em', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M16 8V7C16 5.34315 14.6569 4 13 4H11C9.34315 4 8 5.34315 8 7V8H4V10H5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V10H20V8H16ZM10 8V7C10 6.44772 10.4477 6 11 6H13C13.5523 6 14 6.44772 14 7V8H10ZM7 10H17V19H7V10Z" fill="currentColor"/>
    <path d="M9 12V17H11V12H9Z" fill="currentColor"/>
    <path d="M13 12V17H15V12H13Z" fill="currentColor"/>
  </svg>
);

export default DeleteIcon; 